import { useEffect } from "react";
import { useReveal } from "@/lib/reveal";
import Navbar from "@/components/site/Navbar";
import Hero from "@/components/sections/Hero";
import VousEtesDansCeCas from "@/components/sections/VousEtesDansCeCas";
import Services from "@/components/sections/Services";
import Solutions from "@/components/sections/Solutions";
import PourquoiNous from "@/components/sections/PourquoiNous";
import MidCTABanner from "@/components/sections/MidCTABanner";
import Process from "@/components/sections/Process";
import Preuves from "@/components/sections/Preuves";
import FinalCTA from "@/components/sections/FinalCTA";
import FAQ from "@/components/sections/FAQ";
import ContactForm from "@/components/sections/ContactForm";
import Footer from "@/components/site/Footer";
import WhatsAppFloat from "@/components/site/WhatsAppFloat";
import StickyCTA from "@/components/site/StickyCTA";

export default function Landing() {
  useReveal();

  useEffect(() => {
    document.title =
      "Solmis Habitat — Permis de construire & étude de sol à La Réunion";
  }, []);

  return (
    <div data-testid="landing-page" className="relative bg-white text-foreground">
      <Navbar />
      <main>
        <Hero />
        <VousEtesDansCeCas />
        <Services />
        <Solutions />
        <PourquoiNous />
        <MidCTABanner />
        <Process />
        <Preuves />
        <FAQ />
        <FinalCTA />
        <ContactForm />
      </main>
      <Footer />
      <WhatsAppFloat />
      <StickyCTA />
    </div>
  );
}
